import Header from "../components/dynamic/Header";
import Spinner from "../components/dynamic/Spinner";

const PendingView = () => {
  return (
    <div className="flex flex-col items-center mt-32">
      <Header title="Authenticating" className="mb-4" />
      <Spinner />
    </div>
  );
};

export default PendingView;
